import React from "react";

import { OwnerTypes } from "types";

import Owner from "./MerchantOwnersComponents/owner";

import styles from "./autoCheckList.module.scss";

export const Owners = ({
	loading,
	merchantInfoValues,
	setCheckedOwner1Values,
	setCheckedOwner2Values,
	setCheckedOwner3Values,
	setCheckedOwner4Values,
	setCheckedSignerValues,
	isDisabledOutcome,
	isEditExperianFields,
	isJarisApplication,
}) => {
	return (
		<>
			{merchantInfoValues?.owner1?.id && (
				<div className={styles.wrappAutoCheckListBlock}>
					<Owner
						ownerName="Owner"
						merchantData={merchantInfoValues.owner1}
						ownerType={OwnerTypes.owner1.name}
						loading={loading}
						setCheckedValues={setCheckedOwner1Values}
						applicationId={merchantInfoValues?.applicationId}
						isDisabledOutcome={isDisabledOutcome}
						isEditExperianFields={isEditExperianFields}
						isJarisApplication={isJarisApplication}
					/>
				</div>
			)}
			{merchantInfoValues?.owner2?.id && (
				<div className={styles.wrappAutoCheckListBlock}>
					<Owner
						ownerName="Owner 2"
						merchantData={merchantInfoValues?.owner2}
						ownerType={OwnerTypes.owner2.name}
						loading={loading}
						setCheckedValues={setCheckedOwner2Values}
						applicationId={merchantInfoValues?.applicationId}
						isDisabledOutcome={isDisabledOutcome}
						isEditExperianFields={isEditExperianFields}
						isJarisApplication={isJarisApplication}
					/>
				</div>
			)}
			{merchantInfoValues?.owner3?.id && (
				<div className={styles.wrappAutoCheckListBlock}>
					<Owner
						ownerName="Owner 3"
						merchantData={merchantInfoValues?.owner3}
						ownerType={OwnerTypes.owner3.name}
						loading={loading}
						setCheckedValues={setCheckedOwner3Values}
						applicationId={merchantInfoValues?.applicationId}
						isDisabledOutcome={isDisabledOutcome}
						isEditExperianFields={isEditExperianFields}
						isJarisApplication={isJarisApplication}
					/>
				</div>
			)}
			{merchantInfoValues?.owner4?.id && (
				<div className={styles.wrappAutoCheckListBlock}>
					<Owner
						ownerName="Owner 4"
						merchantData={merchantInfoValues?.owner4}
						ownerType={OwnerTypes.owner4.name}
						loading={loading}
						setCheckedValues={setCheckedOwner4Values}
						applicationId={merchantInfoValues?.applicationId}
						isDisabledOutcome={isDisabledOutcome}
						isEditExperianFields={isEditExperianFields}
						isJarisApplication={isJarisApplication}
					/>
				</div>
			)}
			{merchantInfoValues?.authorizedSigner?.id && (
				<div className={styles.wrappAutoCheckListBlock}>
					<Owner
						ownerName="Authorized Signer"
						merchantData={merchantInfoValues?.authorizedSigner}
						ownerType={OwnerTypes.authorized_signer.name}
						loading={loading}
						setCheckedValues={setCheckedSignerValues}
						applicationId={merchantInfoValues?.applicationId}
						isDisabledOutcome={isDisabledOutcome}
						isEditExperianFields={isEditExperianFields}
						isJarisApplication={isJarisApplication}
					/>
				</div>
			)}
		</>
	);
};
